import type { IconData } from '@stacksjs/iconify-core'

export const controller1: IconData = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"3\" d=\"M44.865 33.492c-.415-9.61-1.708-15.937-2.725-19.566c-.694-2.474-2.84-4.11-5.398-4.357C33.848 9.291 29.5 8.998 24 8.998s-9.847.293-12.74.571c-2.559.247-4.705 1.883-5.399 4.357c-1.017 3.629-2.31 9.956-2.725 19.566c-.171 3.943 2.218 7.506 6.164 7.506q.785-.002 1.473-.045c3.17-.201 5.383-2.716 6.373-5.734l.04-.117c.33-1.006 1.052-1.84 2.077-2.1c1.05-.269 2.63-.537 4.737-.537s3.688.268 4.738.536c1.025.262 1.748 1.095 2.078 2.101l.038.117c.99 3.018 3.205 5.533 6.374 5.733q.688.045 1.472.046c3.947 0 6.336-3.563 6.165-7.506M15 17v8m4-4h-8m22 3v1m-3-4h-1m4-4v1m4 3h-1\"/>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default controller1
